module.exports = __webpack_public_path__ + "img/green-1.b1259a72.png";